export const isEmpty = (value: unknown): boolean => {
    if (value === null || value === undefined) {
        return true;
    }

    if (typeof value === 'string') {
        return !value.length;
    }

    if (value instanceof Date || value instanceof File || typeof value === 'number' || typeof value === 'boolean') {
        return false;
    }

    if (Array.isArray(value)) {
        return !value.length || value.every((v) => isEmpty(v));
    }

    if (Object.values(value).every((v) => isEmpty(v))) {
        return true;
    }

    // Default to not empty when anything else
    return false;
};

export const isNullOrUndefined = (value: unknown): boolean => value === undefined || value === null;

/**
 *
 * @param arr Array of any object
 * @returns boolean
 * This function only checks one level deep. So nested objects are not checked for values.
 */
export const objArrayHasValue = <T>(arr: T[]) =>
    arr.length > 0 && arr.every((l: T) => Object.values(l).some((v) => !isEmpty(v)));

export const allExceptLast = <T>(arr: T[]) => arr.filter((_, i) => i !== arr.length - 1);
